module.exports = __webpack_public_path__ + "img/technology-1.78bc6ff7.jpg";